import React, { FunctionComponent } from 'react';
import { ServiceLinks } from '@belong/ui-components';
import { withBasePath } from '@belong/url-utils';
import { ILinkItem, ISupportCategory, ITileHeader } from '@belong/types';
import { LinkGroupContainer } from 'src/components/pages/CategoryPage/CategoryPage.styles';
import { IArticle } from 'src/models/articles';

export const TEST_ID = {
  LINK_GROUP: 'link-group'
};

export interface IArticleLinkGroup {
  id: string;
  label: string;
  items: IArticle[];
}

// Article sorters / transformers
const alphabetical = (a, b): number => a.title.localeCompare(b.title, 'en', { numeric: true });
const isPromoted = (item: IArticle): boolean => item.promoted;
const isNotPromoted = (item: IArticle): boolean => !isPromoted(item);

// Extract link information from Article.
// Use toggle to decide if article links point to classic or new stack
const toLinkItem =
  (parentId: string) =>
  (item: IArticle): ILinkItem => {
    const isParentCategory = ({ id }: ISupportCategory) => id === parentId;
    const { path = '' } = ((item.categories || []) as ISupportCategory[]).find(isParentCategory) || {};

    return { label: item.title, href: withBasePath(`${path}/${item.metaPageSlug}`) };
  };

const ArticleLinkGroup: FunctionComponent<IArticleLinkGroup> = ({ label, id, items }) => {
  // don't render group if it has no articles
  if (!items.length) {
    return null;
  }

  const linkMapper = toLinkItem(id);
  const linkItems: ILinkItem[] = [
    ...items.filter(isPromoted).sort(alphabetical),
    ...items.filter(isNotPromoted).sort(alphabetical)
  ].map(linkMapper);

  const header: ITileHeader | undefined = label ? { headingVariant: 'large', title: label } : undefined;

  return (
    <LinkGroupContainer data-testid={TEST_ID.LINK_GROUP}>
      <ServiceLinks header={header} linkList={{ items: linkItems }} />
    </LinkGroupContainer>
  );
};

export default ArticleLinkGroup;
